// extracted by mini-css-extract-plugin
export var dropdownButton = "_20-0";
export var fullWidthDropdownButton = "_20-1";
export var icon = "_20-3";
export var iconPlaceholder = "_20-2";
export var menuItemRow = "_20-5";
export var shortcutContainer = "_20-4";